
export class IPPool {
    public ipAddresses: string = '';
    public defaultGateway: string = '';
    public prefixLength: string = '';
    public provider: string = '';
    public ipPoolId: string  = '';
    public ipPoolName: string = '';
}


// WEBPACK FOOTER //
// ./src/app/components/administration-main/interconnect-configuration/model/ip-pool.ts